module.exports = __webpack_public_path__ + "static/media/ic_opportunity_active.7b238086.svg";